import { render, staticRenderFns } from "./CopyURLButton.vue?vue&type=template&id=b9c7c5f4&"
import script from "./CopyURLButton.vue?vue&type=script&lang=ts&"
export * from "./CopyURLButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports